import { Outlet, useLocation } from "react-router-dom";
import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  BreadcrumbList,
  BreadcrumbPage,
  BreadcrumbSeparator,
} from "../../components/ui/breadcrumb"
import { Separator } from "../../components/ui/separator"
import {
  SidebarInset,
  SidebarProvider,
  SidebarTrigger,
} from "../../components/ui/sidebar";
import { AppSidebar } from "./components/app-sidebar";
import { useContext } from "react";
import { AuthContext } from "../../contexts/Auth/Auth.Context";
import { ThemeToggle } from "../../components/theme-toggle";

export default function AppLayout() {
  const location = useLocation();

  const {state} = useContext(AuthContext);

  const pathname = location.pathname;

  return (
    <SidebarProvider>
      <AppSidebar />
      <SidebarInset>
      <header className="flex h-16 shrink-0 items-center justify-between gap-2 transition-[width,height] ease-linear group-has-[[data-collapsible=icon]]/sidebar-wrapper:h-12">
  <div className="flex items-center gap-2 px-4">
    <SidebarTrigger className="-ml-1" />
    <Separator orientation="vertical" className="mr-2 h-4" />
    <Breadcrumb>
      <BreadcrumbList>
        <BreadcrumbItem className="hidden md:block">
          <BreadcrumbLink href="#">
            {pathname.includes("admin") ? "Admin Console" : "WITS Platform"}
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbSeparator className="hidden md:block" />
        <BreadcrumbItem>
            <BreadcrumbPage>
              {pathname.includes("overview")
                ? "User Management"
                : pathname.includes("dataset-management")
                ? "Dataset Management"
                : pathname.includes("articles")
                ? "Articles & News"
                : "Settings"}
            </BreadcrumbPage>
        </BreadcrumbItem>
      </BreadcrumbList>
    </Breadcrumb>
  </div>
  <div className="mr-4">
  <ThemeToggle />
  </div>
</header>

        <main className="px-4 py-2">
            <Outlet />
        </main>
      </SidebarInset>
    </SidebarProvider>
  )
}
